// extracted by mini-css-extract-plugin
module.exports = {"dropdown_menu1":"autosuggestioncomponent_dropdown_menu1__27kMZ"};